module.exports = "/build/web/svg/fullscreen.4906c3994290e0afc51532c16f14855d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/fullscreen.svg
// module id = 109
// module chunks = 24